Object.defineProperty(exports, '__esModule', {
  value: true
});
var React = require('react');
var get = require('lodash.get');
var core = require('@material-ui/core');
var styles = require('@material-ui/styles');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var get__default = /*#__PURE__*/_interopDefaultLegacy(get);
var useStyles = styles.makeStyles(function () {
  return {
    root: {
      cursor: "pointer"
    }
  };
});
var MapLink = function MapLink(_a) {
  var _b = _a.component,
    component = _b === void 0 ? "a" : _b,
    postcode = _a.postcode,
    _c = _a.onClick,
    onClick = _c === void 0 ? function () {} : _c;
  var userAgent = get__default['default'](window, "navigator.userAgent") || "";
  var isApple = /iphone|ipod|ipad|macintosh/.test(userAgent.toLowerCase());
  var classes = useStyles();
  var target = "_blank";
  var rel = "noopener";
  var mapsUrl = isApple ? "https://maps.apple.com/?daddr=" + postcode : "https://maps.google.com/?saddr=My+Location&daddr=" + postcode;
  var handleClick = function handleClick() {
    if (onClick) {
      onClick();
    }
    if (component !== "a") {
      var windowFeatures = [rel];
      window.open(mapsUrl, target, windowFeatures.join(","));
    }
  };
  return React__default['default'].createElement(core.Link, {
    classes: {
      root: classes.root
    },
    onClick: handleClick,
    component: component,
    "data-test": "map-link",
    href: mapsUrl,
    rel: rel,
    target: target
  }, "Map");
};
exports.default = MapLink;